import BpkButton, { SIZE_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';
import { translate } from '@web-platform/shared-universal-translations';

type ExpandableDescriptionProps = {
  description: string;
  maximumLength: number;
  buttonStyle?: any;
  expandedClassName?: string;
  showLess?: boolean;
  onExpand?: (expanded: boolean) => void;
  isExpanded: boolean;
};

const ExpandableDescription = ({
  buttonStyle,
  description,
  expandedClassName,
  isExpanded,
  maximumLength,
  onExpand,
  showLess,
}: ExpandableDescriptionProps) => {
  const isTextTooLong = description.length > maximumLength;
  const collapsed = !isExpanded && isTextTooLong;

  const handleExpand = () => {
    if (onExpand) {
      onExpand(true);
    }
  };

  const handleCollapse = () => {
    if (onExpand) {
      onExpand(false);
    }
  };

  if (collapsed && isTextTooLong) {
    return (
      <div>
        <BpkText tagName="span">{description.substring(0, maximumLength)}...</BpkText>{' '}
        {isTextTooLong && (
          <BpkButton onClick={handleExpand} {...buttonStyle}>
            {translate('ce_destination_info_read_more')}
          </BpkButton>
        )}
      </div>
    );
  }

  return (
    <BpkText>
      <BpkText className={expandedClassName} tagName="p" data-testid="destination-body-long">
        {description}
      </BpkText>
      {showLess && isTextTooLong && (
        <BpkButton onClick={handleCollapse} {...buttonStyle} size={SIZE_TYPES.small}>
          {translate('ktxt_read_less')}
        </BpkButton>
      )}
    </BpkText>
  );
};

export default ExpandableDescription;
